module.exports = __webpack_public_path__ + "img/icon-device-sidebar.cece4489.svg";